import * as i0 from '@angular/core';
import { Injectable, inject, ChangeDetectorRef, Input, ChangeDetectionStrategy, ViewEncapsulation, Component } from '@angular/core';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import * as i1 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
function NzFormItemFeedbackIconComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nz-icon", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("nzType", ctx_r0.iconType);
  }
}
let NzFormStatusService = /*#__PURE__*/(() => {
  class NzFormStatusService {
    formStatusChanges = new ReplaySubject(1);
    static ɵfac = function NzFormStatusService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzFormStatusService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NzFormStatusService,
      factory: NzFormStatusService.ɵfac
    });
  }
  return NzFormStatusService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
// Used in input-group/input-number-group to make sure components in addon work well
let NzFormNoStatusService = /*#__PURE__*/(() => {
  class NzFormNoStatusService {
    noFormStatus = new BehaviorSubject(false);
    static ɵfac = function NzFormNoStatusService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzFormNoStatusService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NzFormNoStatusService,
      factory: NzFormNoStatusService.ɵfac
    });
  }
  return NzFormNoStatusService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
const iconTypeMap = {
  error: 'close-circle-fill',
  validating: 'loading',
  success: 'check-circle-fill',
  warning: 'exclamation-circle-fill'
};
let NzFormItemFeedbackIconComponent = /*#__PURE__*/(() => {
  class NzFormItemFeedbackIconComponent {
    cdr = inject(ChangeDetectorRef);
    status = '';
    iconType = null;
    ngOnChanges(_changes) {
      this.updateIcon();
    }
    updateIcon() {
      this.iconType = this.status ? iconTypeMap[this.status] : null;
      this.cdr.markForCheck();
    }
    static ɵfac = function NzFormItemFeedbackIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzFormItemFeedbackIconComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzFormItemFeedbackIconComponent,
      selectors: [["nz-form-item-feedback-icon"]],
      hostAttrs: [1, "ant-form-item-feedback-icon"],
      hostVars: 8,
      hostBindings: function NzFormItemFeedbackIconComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("ant-form-item-feedback-icon-error", ctx.status === "error")("ant-form-item-feedback-icon-warning", ctx.status === "warning")("ant-form-item-feedback-icon-success", ctx.status === "success")("ant-form-item-feedback-icon-validating", ctx.status === "validating");
        }
      },
      inputs: {
        status: "status"
      },
      exportAs: ["nzFormFeedbackIcon"],
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 1,
      vars: 1,
      consts: [[3, "nzType"]],
      template: function NzFormItemFeedbackIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵconditionalCreate(0, NzFormItemFeedbackIconComponent_Conditional_0_Template, 1, 1, "nz-icon", 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.iconType ? 0 : -1);
        }
      },
      dependencies: [NzIconModule, i1.NzIconDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzFormItemFeedbackIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzFormItemFeedbackIconComponent, NzFormNoStatusService, NzFormStatusService };
